import CreateAccount from 'pages/CreateAccount/CreateAccount';

// @(ruvmark) Where I would map state and dispatch to props.
export default CreateAccount;
